export default __webpack_public_path__ + "static/media/information--tram-bus-stop--g2.742fb913.png";